/**
 * TV Series Row to VOD section
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 30.01.2015-19:42
 */

lmApp.controller('LmTvSeriesRowController', ['$rootScope', '$scope', '$interval', '$timeout', '$compile', 'AssetService', 'MetadataService',
  function ($rootScope, $scope, $interval, $timeout, $compile, AssetService, MetadataService) {

    if (!$scope.asset || $scope.isHeader) {
      return;
    }

    $scope.actionShown = false;

    $scope.parseTvSeriesAsset = function (asset) {

      $scope.assetData = angular.copy(asset);
      $scope.prepareTvSeriesStatus();

      if (!$scope.posterData) $scope.posterData = {};

      if ($scope.updateIntreval && $scope.assetData._status.poster) {
        $interval.cancel($scope.updateIntreval);
      } else if (!$scope.assetData._status.poster) {

        if ($scope.updateIntreval) {
          $interval.cancel($scope.updateIntreval);
        }

        $scope.updateIntreval = $interval(function () {

          $rootScope.$broadcast($rootScope.EVENTS.UPDATE_VOD_COLLECTION, {
            id: $scope.assetData.id,
            isSilentUpdate: true
          });
        }, 30 * 1000);
      }

      AssetService.GetPoster(asset)
        .then(function (url) {
          $scope.posterData.t = _.get(_.find(asset.resources, {type: 'picture'}), 'uptime_time') || Date.now();
          $scope.posterData.url = url;
        });
    };

    $scope.prepareTvSeriesStatus = function () {
      $scope.assetData._status = {
        poster: _.find($scope.assetData.resources, {category: 'poster_blueprint'}) && _.find($scope.assetData.resources, {category: 'poster_blueprint'}).is_deployed,
        rental: MetadataService.Rental.Check($scope.assetData)
      };
    };

    $scope.deleteAsset = function (event) {
      if (event && event.stopPropagation) event.stopPropagation();
      if (event && event.preventDefault) event.preventDefault();

      $scope.deleteFn(event);
    };

    $scope.showSeasons= function (event) {
      if (event && event.stopPropagation) event.stopPropagation();
      if (event && event.preventDefault) event.preventDefault();

      $scope.assetData._PrivateData.seasonsShow = !$scope.assetData._PrivateData.seasonsShow;

      $scope.expandFn(event);
    };

    $scope.parseTvSeriesAsset($scope.asset);
    $scope.prepareTvSeriesStatus();

    $scope.assetWatcher = $scope.$watchCollection('asset', function (newValue) {
      if (!newValue) return;

      $scope.parseTvSeriesAsset(newValue);
    });

    $scope.$on('$destroy', function () {
      $scope.assetWatcher();
      $interval.cancel($scope.updateIntreval);
    });
}]);

lmApp.
  directive('lmTvSeriesRow', function () {
    return {
      restrict: 'E',
      scope: {
        asset: '=',
        editFn: '&',
        deleteFn: '&',
        expandFn: '&',
        isHeader: '='
      },
      replace: true,
      controller: 'LmTvSeriesRowController',
      templateUrl: 'lm-table-rows/tv-series-row/tv-series-row.tpl.html'
    };
  });
